module.exports = __webpack_public_path__ + "static/media/table.9c4c9add.svg";